// extracted by mini-css-extract-plugin
export default {"card":"rouletteCatItem_card__9NITf","active":"rouletteCatItem_active__rcT25"};